/* import __COLOCATED_TEMPLATE__ from './string-filter-unknown-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();